import { render, staticRenderFns } from "./bullish_harami_cross.vue?vue&type=template&id=284dfd72"
import script from "./bullish_harami_cross.vue?vue&type=script&lang=js"
export * from "./bullish_harami_cross.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports